module.exports = __webpack_public_path__ + "img/facebook-white.49387f94.svg";